"use client";
import { ConsentBanner, ConsentProvider } from "react-hook-consent";
import "react-hook-consent/dist/styles/style.css";
import "@/styles/globals.css";
import { cn } from "../lib/utils";
import { Toaster } from "react-hot-toast";
import { Toaster as ToasterV2 } from "@/components/ui/sonner";
import { Plausible, Umami } from "@/components/analytics/umami";
import { CookieList, fontSans } from "@/lib/util/boot";
import { GAnalytics, MicrosoftClarity } from "@/components/analytics/ga";
import { MetaPixel } from "@/components/analytics/meta-pixel";
import { UTMTracker } from "@/components/analytics/utm-tracker";
import { TRPCReactProvider } from "@/trpc/react";



export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html lang="de" className={`h-full w-full bg-background text-foreground`}>
      <head>
        {/* <script src="https://unpkg.com/react-scan/dist/auto.global.js" async /> */}
      </head>
      <body
        className={cn(
          "h-full min-h-screen w-full bg-background font-sans antialiased",
          fontSans.variable,
        )}
      >
        <ConsentProvider
          options={{
            services: [
              ...CookieList.map((cookie) => ({
                id: cookie.key,
                name: cookie.title,
                scripts: [],
                cookies: [{ pattern: cookie.key }],
                localStorage: [],
                sessionStorage: [],
                description: cookie.description,
                mandatory: cookie.required,
              })),
            ],
            theme: "light",
          }}
        >
          <main className="relative h-full w-full">
            <TRPCReactProvider>{children}</TRPCReactProvider>
          </main>
          <ConsentBanner
            settings={{
              hidden: false,
              label: "Mehr",
              modal: {
                title: "Privatsphäre-Einstellungen",
                description: `Diese Webseite verwendet Cookies. Einige sind notwendig,
                    andere helfen uns, die Webseite zu verbessern. Sie können Ihre
                    individuellen Einstellungen vornehmen.`,
                decline: {
                  hidden: false,
                  label: "Alle ablehnen",
                },
                approve: {
                  label: "Akzeptieren",
                },
                approveAll: {
                  label: "Alle akzeptieren",
                },
              },
            }}
            decline={{ hidden: false, label: "Alle ablehnen" }}
            approve={{ label: "Akzeptieren" }}
          >
            <>
              Diese Webseite verwendet Cookies. Einige sind notwendig, andere
              helfen uns, die Webseite zu verbessern. Sie können Ihre
              individuellen Einstellungen vornehmen.
            </>
          </ConsentBanner>
          <GAnalytics />
          <MetaPixel />
          <MicrosoftClarity />
          <UTMTracker />
        </ConsentProvider>

        <Toaster />
        <ToasterV2 />
        <Umami />
        <Plausible />
      </body>
    </html>
  );
}
